module.exports = [
	{
		"match": "after-effects-project-files",
		"title": "Need Music?",
		"content": "What good is an AE Project if it doesn't have the perfect music to go along with it? Find <a href=\"https://audiojungle.net/category/music\">beautiful stock music</a> on AudioJungle.",
		"button_label": "Browse Stock Music",
		"icon_source": "audio_v2.png",
		"link": "https://audiojungle.net/category/music"
	},
	{
		"match": "motion-graphics",
		"title": "Need Sound Effects?",
		"content": "What good is a video if it doesn't have the perfect sound effects to go along with it? Find <a href=\"https://audiojungle.net/category/sound\">amazing stock sound effects</a> on AudioJungle.",
		"button_label": "Browse Sound Effects",
		"icon_source": "audio_v2.png",
		"link": "https://audiojungle.net/category/music"
	},
	{
		"match": "cinema-4d-templates",
		"title": "Need C4D Models?",
		"content": "Need 3D models to go along with your Cinema 4D templates? If so, check out all the <a href=\"https://3docean.net/attributes/created-in/cinema%204d%20r10\">amazing C4D models</a> on 3dOcean. ",
		"button_label": "Browse C4D Models",
		"icon_source": "3d.png",
		"link": "https://3docean.net/attributes/created-in/cinema%204d%20r10"
	},
	{
		"match": "stock-footage",
		"title": "Need Music?",
		"content": "What good is a video if it doesn't have the perfect music to go along with it? Find <a href=\"https://audiojungle.net/category/music\">beautiful stock music</a> on AudioJungle.",
		"button_label": "Browse Stock Music",
		"icon_source": "audio_v1.png",
		"link": "https://audiojungle.net/category/music"
	},
	{
		"match": "after-effects-project-files/logo-stings",
		"title": "Audio Logo/Idents",
		"content": "Find the perfect audio Logo/Ident for your Logo Sting in our dedicated <nobr>Logos & Idents</nobr> category on AudioJungle.",
		"button_label": "Browse Audio Idents",
		"icon_source": "games_v1.png",
		"link": "https://audiojungle.net/category/logos-idents"
	}
];


//////////////////
// WEBPACK FOOTER
// ./config/sites/ads/videohive.json
// module id = 627
// module chunks = 1